import { render, staticRenderFns } from "./AllInvestorsHistoryTabs.vue?vue&type=template&id=26bd8331"
import script from "./AllInvestorsHistoryTabs.vue?vue&type=script&lang=js"
export * from "./AllInvestorsHistoryTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports